// 工場紹介詳細：ご紹介したアイテム スライダー初期化
// PC は Splide、SP は CSS grid 横スクロール。matchMedia でリサイズ追従。

(() => {
  const SP_MQ = window.matchMedia('(max-width: 740px)');
  const instances = new WeakMap();

  function applyMode(el) {
    if (typeof Splide === 'undefined') return;

    if (SP_MQ.matches) {
      const inst = instances.get(el);
      if (inst) {
        try { inst.destroy(true); } catch (e) { /* noop */ }
        instances.delete(el);
      }
      el.classList.add('is-css-scroll');
      return;
    }

    el.classList.remove('is-css-scroll');
    if (instances.has(el)) return;

    const splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrows: true,
      breakpoints: {
        999: { perPage: 3 },
      },
    });
    splide.mount();
    instances.set(el, splide);
  }

  function bootstrap(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-factory-article-featured]').forEach(applyMode);
  }

  document.addEventListener('DOMContentLoaded', () => bootstrap());

  if (typeof SP_MQ.addEventListener === 'function') {
    SP_MQ.addEventListener('change', () => bootstrap());
  } else if (typeof SP_MQ.addListener === 'function') {
    SP_MQ.addListener(() => bootstrap());
  }

  document.addEventListener('shopify:section:load', (event) => {
    bootstrap(event.target);
  });
})();
